import React from "react";
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import GBDialog from "../GBDialog";
import Button from "@mui/material/Button";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import HourglassFullIcon from "@mui/icons-material/HourglassFull";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { formatDateTime } from "../../utilities";

const styles = {
    note: {
        marginBottom: "15px",
    },
    failed: {
        color: "red",
        marginTop: "6px",
    },
    succeeded: {
        color: "green",
        marginTop: "6px",
    },
    startedAtColumn: {
        width: "200px",
    },
    yesButton: {
        marginRight: "15px",
    },
};

const RunHistoryDialogDelete = ({ t, ...rest }) => {
    const { open, onClose, selectedRun, onDeleteRun } = rest;

    if (!open || !selectedRun) {
        return null;
    }

    const onYesClick = () => {
        onDeleteRun();
        onClose();
    };

    return (
        <GBDialog
            open={true}
            onClose={onClose}
            title={t("Delete run confirmation")}
            content={
                <>
                    <div style={styles.note}>{t("Are you sure you want to delete this run?")}</div>

                    <TableContainer style={{ width: "initial", minWidth: 200, maxWidth: 800, maxHeight: 600 }}>
                        <Table
                            className={"myTable2"}
                            stickyHeader
                        >
                            {/* <Table sx={styles.table}> */}
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Run name")}</TableCell>
                                    <TableCell style={styles.startedAtColumn}>{t("Started at")}</TableCell>
                                    <TableCell>{t("Status")}</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {[selectedRun].map((run) => (
                                    <TableRow key={run.name}>
                                        <TableCell>
                                            <span>{run.name}</span>
                                        </TableCell>
                                        <TableCell>{formatDateTime(run.startedAt)}</TableCell>
                                        <TableCell>
                                            <Tooltip
                                                title={
                                                    run.completed
                                                        ? !run.failed
                                                            ? t("Run has completed")
                                                            : t("Run failed")
                                                        : t("Run is in progress")
                                                }
                                            >
                                                {run.completed ? (
                                                    <HourglassFullIcon
                                                        sx={!run.failed ? styles.succeeded : styles.failed}
                                                    />
                                                ) : (
                                                    <HourglassEmptyIcon />
                                                )}
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
            actions={
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onYesClick}
                        style={styles.yesButton}
                    >
                        {t("Yes")}
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onClose}
                    >
                        {t("No")}
                    </Button>
                </>
            }
        />
    );
};

RunHistoryDialogDelete.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    selectedRun: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        startedAt: PropTypes.instanceOf(Date).isRequired,
        completed: PropTypes.bool.isRequired,
    }),
    onDeleteRun: PropTypes.func.isRequired,
};

RunHistoryDialogDelete.defaultProps = {};

export default withTranslation()(RunHistoryDialogDelete);
